import React, { useEffect } from 'react';
import { connect } from 'react-redux';
//Actions
import { logGet } from '../../../actions/log';
//Components
import LogDate from '../LogDate';
import VisitorId from './VisitorId';
import VisitorVehicle from './VisitorVehicle';
import Loader from 'locki-dashboard-navigation/dist/loader';
import Table from 'locki-dashboard-navigation/dist/table';
//Material-ui
import Paper from '@material-ui/core/Paper';

function GuardLog({ clan, log, logGet }) {
  useEffect(() => {
    logGet('guard', clan);
  }, []);

  const data = log ? log.guard : undefined;

  const columns = [
    {
      id: 'date',
      align: 'left',
      padding: 'none',
      label: 'Fecha',
      component: LogDate,
    },
    { id: 'address', align: 'right', label: 'Domicilio' },
    {
      id: 'visitorIdUrl',
      align: 'right',
      label: 'Visitante',
      component: VisitorId,
    },
    {
      id: 'visitorVehicleUrl',
      align: 'right',
      label: 'Visitante',
      component: VisitorVehicle,
    },
    { id: 'door', align: 'right', padding: 'none', label: 'Puerta' },
  ];
  const table = (
    <Paper className="general-paper">
      <Table data={data} order="desc" columns={columns} title="Registro" />
    </Paper>
  );
  return data === undefined ? <Loader /> : table;
}

const mapStateToProps = (state) => ({
  log: state.log,
});

const mapDispatchToProps = (dispatch) => ({
  logGet: (method, clan) => dispatch(logGet(method, clan)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GuardLog);
